module.exports = __webpack_public_path__ + "img/siren-on.be7c5deb.svg";